import {FC, ReactNode, useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {logout} from 'slices/auth';
import {RootState} from 'store';
import {AuthContext} from 'context/AuthContext';


interface AuthProviderProps {
    children: ReactNode;
}

export const AuthProvider: FC<AuthProviderProps> = ({children}) => {
    const dispatch = useDispatch();
    const isAuthorized = useSelector((state: RootState) => state.auth.isAuthorized);
    const [authLoaded, setAuthLoaded] = useState(false);

    useEffect(() => {
        setAuthLoaded(true);
    }, []);

    return (
        <AuthContext.Provider value={{
            isAuthorized,
            authLoaded,
            logout: () => dispatch(logout()),
        }}>
            {children}
        </AuthContext.Provider>
    );
};
